module.exports = __webpack_public_path__ + "img/Krungthai.b59fe9ee.png";